import { LIMPAR_VIAGENS } from '../types'

export default function limparViagens () {
  return {
    type: LIMPAR_VIAGENS,
  }
}
